module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-04.0b2da437.jpg";